<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper" v-loading="loading">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'customers'}">Customers</router-link>
          </li>
          <li class="active">
            <a href="#">View Customer</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content customers-content">
        <div class="box" v-loading="loading">
          <div class="box-body">
            <el-form
              :model="customer"
              :rules="rules"
              ref="customer"
              label-width="120px"
              label-position="top"
            >
              <el-form-item label="Name" prop="name">{{customer.name}}</el-form-item>
              <el-form-item label="Api key" prop="customerSecretKey">{{customer.customerSecretKey}}</el-form-item>
            </el-form>
            <hr>
          </div>

          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "customer-view",
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      customer: {
        id: "",
        name: "",
        customerSecretKey: "",
        created: ""
      }
    };
  },
  methods: {
    ...mapActions("customers", ["getCustomer"])
  },
  mounted() {
    this.loading = true;
    this.getCustomer(this.id)
      .then(resp => {
        this.loading = false;
        this.customer = resp.data;
      })
      .catch(_ => {
        this.loading = false;
        this.$router.push({ name: "404" });
      });
  }
};
</script>



// WEBPACK FOOTER //
// View.vue?773cdeca